export function formatCamelCaseToCapitalized(str) {
  return str
    .replace(/([A-Z])/g, ' $1') // insert space before capital letters
    .replace(/^./, (s) => s.toUpperCase()); // capitalize the first letter
}

export const formatNumberWithCommas = (number) => {
  if (typeof number !== 'number') return number;
  return new Intl.NumberFormat('en-US').format(number);
};
